import { nanoid } from 'nanoid';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DEFAULT_CHECKLIST_COLOR,
  DEFAULT_CHECKLIST_ICON,
} from 'src/Components/Checklists/checklistVisuals.helper';
import { ChecklistForm } from 'src/Components/Forms/Checklist/ChecklistForm';
import { useCreateChecklistForm } from 'src/Hooks/Forms/useCreateChecklistForm';
import useUpdateChecklist from 'src/Hooks/Mutations/useUpdateChecklist';
import useFetchChecklist from 'src/Hooks/Queries/useFetchChecklist';

import { Props } from './ChecklistEditionFormWrapper.types';

const ChecklistEditionFormWrapper = ({ onCreate, onCancel, checklistId }: Props) => {
  const { form, addItem, removeItem, reorderItems } = useCreateChecklistForm();
  const { data: checklist } = useFetchChecklist(checklistId);
  const { t } = useTranslation();
  const { mutate } = useUpdateChecklist({ onSuccess: () => onCreate() });

  useEffect(() => {
    if (checklist) {
      form.setValues({
        title: checklist.title,
        items: checklist.items.map(item => ({
          label: item.label,
          localId: nanoid(),
          id: item.id,
        })),
        icon: checklist.icon ?? DEFAULT_CHECKLIST_ICON,
        color: checklist.color ?? DEFAULT_CHECKLIST_COLOR,
        templateKey: checklist.templateKey,
      });
    }
  }, [checklist]);

  return (
    <ChecklistForm
      onCancel={onCancel}
      form={form}
      onSubmit={form.onSubmit(values => {
        mutate({ checklistId, updateData: values });
      })}
      submitButtonLabel={t('checklist.form.add', 'Enregistrer la checklist')}
      addItem={addItem}
      removeItem={removeItem}
      reorderItems={reorderItems}
    />
  );
};

export default ChecklistEditionFormWrapper;
